/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Paths to the data directories for various H5P exercise types.
 */
export type ExerciseTypePath = 'dialog_cards' | 'drag_text' | 'fill_blanks' | 'find_words' | 'mark_words' | 'multi_choice' | 'voc_list';

export const ExerciseTypePath = {
    DialogCards: 'dialog_cards' as ExerciseTypePath,
    DragText: 'drag_text' as ExerciseTypePath,
    FillBlanks: 'fill_blanks' as ExerciseTypePath,
    FindWords: 'find_words' as ExerciseTypePath,
    MarkWords: 'mark_words' as ExerciseTypePath,
    MultiChoice: 'multi_choice' as ExerciseTypePath,
    VocList: 'voc_list' as ExerciseTypePath
};

